import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  changes: [],
};

const slice = createSlice({
  name: 'changes',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.changes || state.changes.length === 0) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getChangesSuccess(state, action) {
      state.isLoading = false;
      state.changes = action.payload;
      state.isInitializing = false;
    },

    purgeChangeList(state) {
      state.changes = [];
    },
  },
});

export const { startLoading, hasError, getChangesSuccess, purgeChangeList } = slice.actions;

export default slice.reducer;
